import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaExclamationCircle, FaSpinner, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../authContext/AuthProvider';
import '../styles/Auth.css';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const { forgotPassword } = useAuth();

  const validateForm = () => {
    if (!email) {
      setError('Email is required');
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    const result = await forgotPassword(email);
    setIsSubmitting(false);

    if (result.success) {
      setIsSubmitted(true);
      toast.success('Reset instructions sent to your email');
    } else {
      toast.error(result.error);
    }
  };

  if (isSubmitted) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="success-icon">
              <FaEnvelope size={40} />
            </div>
            <h1>Check Your Email</h1>
            <p>
              We've sent password reset instructions to your email address.
              Please check your inbox and follow the instructions.
            </p>
          </div>
          <div className="auth-form">
            <div style={{ 
              background: '#EEF2FF', 
              border: '1px solid #C7D2FE', 
              borderRadius: '8px', 
              padding: '16px', 
              marginBottom: '20px',
              textAlign: 'left'
            }}>
              <p style={{ margin: '0 0 12px 0', fontWeight: '600', color: '#4338CA' }}>
                📧 Email contains:
              </p>
              <ul style={{ margin: '0', paddingLeft: '20px', color: '#4B5563', fontSize: '14px' }}>
                <li>A reset token (copy this)</li>
                <li>Instructions to complete the reset</li>
              </ul>
              <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: '#6B7280' }}>
                Or click the link in the email to auto-fill the token.
              </p>
            </div>
            <button
              type="button"
              className="submit-button"
              onClick={() => navigate('/reset-password')}
              style={{ marginBottom: '12px' }}
            >
              Go to Reset Password Page
            </button>
            <button
              type="button"
              className="submit-button"
              onClick={() => navigate('/login')}
              style={{ background: '#6B7280' }}
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forgot Password</h1>
          <p>Enter your email to reset your password</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder="Enter your email"
              className={error ? 'is-invalid' : ''}
              disabled={isSubmitting}
            />
            {error && (
              <div className="error-text">
                <FaExclamationCircle />
                {error}
              </div>
            )}
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <FaSpinner className="spin" />
                <span>Sending...</span>
              </>
            ) : (
              'Send Reset Instructions'
            )}
          </button>

          <div className="auth-links">
            <Link to="/login">Back to Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen; 